module.exports = __webpack_public_path__ + "img/hand-left-top.c80300f7.png";